module.exports = __webpack_public_path__ + "img/live4.368b1926.png";